// frontend/src/components/features/OnlineBadge.jsx
// Online availability badge for game tiles

import React from 'react';
import { Globe } from 'lucide-react';

const OnlineBadge = ({ onlineVenues = [], className = "", style = {} }) => {
  if (!onlineVenues || onlineVenues.length === 0) {
    return null;
  }

  // Get venue display names
  const getVenueDisplayName = (venueCode) => {
    const venueNames = {
      'bga': 'BGA',
      'steam': 'Steam',
      'epic': 'Epic',
      'gog': 'GOG',
      'origin': 'Origin',
      'uplay': 'Uplay',
      'tabletopsimulator': 'Tabletop Sim',
      'yucata': 'Yucata',
      'online': 'Online'  // Generic online indicator from Find in Collection API
    };
    return venueNames[venueCode] || venueCode.toUpperCase();
  };

  // Determine if any venues require premium
  const hasPremium = onlineVenues.some(venue => venue.access_type === 'premium_required');

  const badgeStyle = {
    backgroundColor: hasPremium ? 'var(--pista-orange-primary, #ff9800)' : 'var(--pista-green-primary, #4caf50)',
    color: 'white',
    padding: '0 0.75rem',
    borderRadius: '8px',
    fontSize: '0.8rem',
    fontWeight: '500',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    zIndex: 10,
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    transition: 'all 0.2s ease',
    cursor: 'pointer',
    height: '32px',
    minHeight: '32px',
    whiteSpace: 'nowrap',
    ...(style?.position === undefined && {
      position: 'absolute',
      top: '0.5rem',
      left: '50%',
      transform: 'translateX(-50%)',
    }),
    ...style
  };

  const venuesText = onlineVenues
    .map(venue => getVenueDisplayName(venue.venue_code))
    .join(', ');

  // Check if this is just a generic online indicator from Find in Collection API
  const isGenericOnline = onlineVenues.length === 1 && onlineVenues[0].venue_code === 'online';

  return (
    <div
      className={`online-badge ${className}`}
      style={badgeStyle}
      title={isGenericOnline ? 'Available to play online' : `Available online: ${venuesText}${hasPremium ? ' (Premium required for some venues)' : ''}`}
    >
      <Globe size={14} />
    </div>
  );
};

export default OnlineBadge;
